import React, { useEffect } from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import { history } from "../../index";
import { HeaderComponent, BackgroundComponent, BottomNavBar } from "../common";
import { store } from "../../redux/store";
import { useSelector } from "react-redux";
import {
  Examination,
  Interview,
  Investigation,
  Diagnosis,
  ExamEvaluation,
  InvestigationEvaluation,
  FinalDiagnosis,
  DiagnosisEvaluation,
  Management,
  ManagementEvaluation,
  HistorySummary,
  CaseSummary,
  FinalMarks,
} from "../";

function GameMenu() {
  const { page } = useSelector((state) => state.gameStates);
  const renderModal = () => {
    switch (page) {
      case "/history":
        return <Interview />;
      case "/historysummary":
        return <HistorySummary />;
      case "/diagnosis":
        return <Diagnosis />;
      case "/diagnosis2":
        return <Diagnosis />;
      case "/exam":
        return <Examination />;
      case "/examevaluation":
        return <ExamEvaluation />;
      case "/investigation":
        return <Investigation />;
      case "/investigationevaluation":
        return <InvestigationEvaluation />;
      case "/finaldiagnosis":
        return <FinalDiagnosis />;
      case "/diagnosisevaluation":
        return <DiagnosisEvaluation />;
      case "/management":
        return <Management />;
      case "/managementevaluation":
        return <ManagementEvaluation />;
      case "/finalmarks":
        return <FinalMarks />;
      case "/casesummary":
        return <CaseSummary />;
      default:
        return <></>;
    }
  };

  useEffect(() => {
    const { status } = store.getState().gameStates;
    if (status <= 1 || status > 15) history.push("/cases");
  }, []);

  return (
    <React.Fragment>
      <CssBaseline />
      <BackgroundComponent transparent={!!page} />
      <HeaderComponent />
      {!page ? <BottomNavBar /> : <></>}
      {renderModal()}
    </React.Fragment>
  );
}

export default GameMenu;
